import { render, staticRenderFns } from "./permissions-header.vue?vue&type=template&id=59c49af0&scoped=true&"
var script = {}
import style0 from "./permissions-header.vue?vue&type=style&index=0&id=59c49af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c49af0",
  null
  
)

export default component.exports